import { createContext } from "react";

export const defaultLogicState = {
    internal: {
        local: {},
        global: {},
        stream: [],
    },
    external: null,
};

export const defaultQuizState = {
    responses: {},
    quizId: null,
    availableQuestions: null,
    questionDisplayCount: 0,
    isComplete: false,
    previousQuestionIndex: null,
    activeQuestionIndex: -1,
    dateCompleted: "",
};

const defaultLogicStateContext = {
    logicState: {
        ...defaultLogicState,
    },
    setLogicState: (logicState: LogicState) => {
        return logicState;
    },
    storeLogicState: (logicState: LogicState) => logicState,
};

export const STORAGE_KEY_LOGIC_STATE = "logic/logicState";

export enum QuizType {
    Default = "DEFAULT",
    LinearRating = "LINEAR_RATING",
    KnowledgeTest = "KNOWLEDGE_TEST",
    SimpleChecklist = "SIMPLE_CHECKLIST",
    Informational = "INFORMATIONAL",
    Priorities = "PRIORITIES",
}

export type ComputedLogicState = {
    local: any;
    global: any;
    stream: any[];
};

export type LogicState = {
    internal?: ComputedLogicState | null;
    external?: ComputedLogicState | null;
};

export type QuizState = {
    responses: any;
    quizId: string | null;
    availableQuestions: any[];
    questionDisplayCount: number;
    isComplete: Boolean;
    previousQuestionIndex: number;
    activeQuestionIndex: number;
    dateCompleted: string;
};

export interface QuizContextInterface {
    start(): void;
    next(responses: any[]): void;
    previous(): void;
    redo(): Promise<any>;
    getQuiz(): any;
    getQuestion(questionId: string): any;
    getOptions(questionId: string, question?: any): any;
    logicState: LogicState;
    quizState: QuizState;
    headerHeight: number;
}

export interface LogicContextInterface {
    logicState: LogicState;
    setLogicState(logicState: LogicState);
    storeLogicState(logicState: LogicState);
}

export const QuizContext = createContext<QuizContextInterface | null>(null);

export const QuizOrderContext = createContext<any | null>(null);

export const LogicStateContext = createContext<LogicContextInterface>(
    defaultLogicStateContext,
);
